// Campaign detail page (CHG-1236 / ITER-3359).
//
// Thin per the v7 brief: ≤30 LOC. All configuration in @generated/screens.
// Future generator regenerates campaignDetailConfig from
// campaign.entity-hint.yaml (CHG-1228) without touching this file.
//
// Spec: specs/tier-05-experience/campaign-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { campaignDetailConfig } from "../generated/screens/campaign-detail";

export function CampaignDetail() {
  return <DetailPage config={campaignDetailConfig} />;
}
